/**
 * The citation number's pill, shared by the interactive and static variants so a report reads
 * the same whether it is opened in the app, embedded read-only, or printed.
 *
 * Deliberately not a `Badge`: Badge wraps its content in a controlled tooltip, which races the
 * interactive citation's own and makes hovering flicker.
 */
export const CITATION_PILL_CLASS =
  'ml-[3px] inline-flex aspect-square min-w-[18px] items-center justify-center rounded-full bg-accent px-1 align-middle text-xs font-medium tabular-nums text-accent-foreground dark:text-neutral-100';
